module.exports = __webpack_public_path__ + "static/media/achievement-13.08232d88.png";